const links = [
	{
		path: '/hddm/',
		home: true,
	},
	{
		path: '/hddm/programm/',
		name: 'Программа',
		active: true,
	},
	{
		path: '/hddm/sessions/',
		name: 'Командные сессии',
		active: true,
	},
];
export default links;
